import { format, isAfter, isSameDay } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { Project } from '~/types/project';

export default function bidDeadline(project: Project) {
  const currentDate = new Date();
  const bidDeadlineData = project?.bidDeadline || project?.portfolio?.bidDeadline as string;
  const bidDeadline = utcToZonedTime(bidDeadlineData, 'UTC');
  const hasBidDeadlinePassed = isAfter(currentDate, bidDeadline) || isSameDay(currentDate, bidDeadline);

  return {
    bidDeadlineData,
    formattedBidDeadline: bidDeadline,
    hasBidDeadlinePassed,
    bidDeadlineDisplay: bidDeadlineData && `Bidding due ${format(bidDeadline, 'MMM dd')}`
  };
}